import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  CardOrden,
  ContainerP5,
} from "./localStyle";
import { showToaster } from "global/context/action/toaster/toaster";
import camelize from "global/utils/camelize";
import { resetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { PortalContext } from "_+_Portal/context/Provider";
import {
  wsGetAllDemandaQr,
  wsGetVerificarOsAtencionSinTurnoQr,
  wsPostTomarAtencionSinTurnoQr,
} from "_+_Portal/_-_Autocheckin/context/action/atencionSinTurno";
import { hideModal, showModal } from "global/context/action/modal/modal";
import ModalTurnoParticular from "_+_Portal/_-_Autocheckin/components/genericos/ModalTurnoParticular/ModalTurnoParticular";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { setTurnoForced } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import TurnoNoEncontrado from "_+_Portal/components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import AdvertenciaCentro from "_+_Portal/_-_Autocheckin/components/genericos/AdvertenciaCentro/AdvertenciaCentro";

const AgendasDisponibles = ({ setError }) => {
  // -------------------------  useContex  ----------------------------
  const {
    pasoDispatch,
    atencionSinTurnoDispatch,
    turnosSeleccionadosDispatch,
    turnosAutoCheckInDispatch,
  } = useContext(AutocheckContext);
  const { ordenDigitalState, ordenDigitalDispatch } = useContext(PortalContext);
  const { modalDispatch, toasterDispatch } = useContext(GlobalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [agendaList, setAgendaList] = useState([]);
  const [loading, setLoading] = useState(true);
  const centroQR = sessionStorage.getItem("centroID");
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const volver = () => {
    resetOrdenDigitalEstudio()(ordenDigitalDispatch);
    setPaso("Home")(pasoDispatch);
  };

  let dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const advertenciaCentro = (turno) => {
    showModal(
      <AdvertenciaCentro
        tomarTurno={() => tomarTurnoDemanda(turno)}
        infoTurno={turno}
      />,
      "Atención",
      dissmiss,
      false,
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const tomarTurnoDemanda = (turno) => {
    let nextStep = (isCorrect, data) => {
      setLoading(true);
      if (isCorrect) {
        if (data.codigo === 91) {
          setLoading(false);
          showModal(
            <ModalTurnoParticular
              tomarTurno={() => finalizarProyecto(turno, false, true)}
              mensajeError={data.mensaje}
              osAlternativa={true}
            />,
            "La obra social no cubre",
            dissmiss,
            false,
            {},
            "centro",
            true
          )(modalDispatch);
        } else if (data.codigo === 9) {
          setLoading(false);
          showModal(
            <ModalTurnoParticular
              tomarTurno={() => finalizarProyecto(turno, true, false)}
              mensajeError={data.mensaje}
            />,
            "La obra social no cubre",
            dissmiss,
            false,
            {},
            "centro",
            true
          )(modalDispatch);
        } else {
          finalizarProyecto(turno);
        }
      } else {
        setLoading(false);
        showToaster(
          {
            texto: data !== "" ? data : "Ha ocurrido un error",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    };
    setLoading(true);
    wsGetVerificarOsAtencionSinTurnoQr(
      turno.idMedico,
      turno.idEspe,
      nextStep
    )();
  };

  const finalizarProyecto = (turno, particular, osAlternativa) => {
    setLoading(true);
    let dto = {
      // idPaciente: paciente.codigo,
      idMedico: turno.idMedico,
      idEspecialidad: turno.idEspe,
      idCentro: turno.idCentro,
      particular,
      osAlternativa,
      idOrden: ordenDigitalState.ordenDigital.altaTurno,
      idGrupoMed: ordenDigitalState.ordenDigital.grupoMed[0].id,
      idMedSolicitante: ordenDigitalState.ordenDigital.idMedSolicitante,
    };
    let nextStep = (isCorrect, element) => {
      if (isCorrect) {
        if (element?.idCentro?.toString() === centroQR) {
          let turno = {
            idturno: element["idturno"],
            idMedico: element["idMedico"],
            idRecepcion: element["idRecepcion"],
            idCentro: element["idCentro"],
            medico: element["medico"],
            fecha: element["fecha"],
            hora: element["hora"],
            especialidad: element["especialidad"],
            centro: element["centro"],
            checkin: element["checkin"],
            flgSaldada: element["flgSaldada"],
            coordenadaGps: element["coordenadaGps"],
            selected: true,
            idProtocolo: element["idProtocolo"],
            presente: element["presente"],
            consultorio: element["consultorio"],
            flgSoloConsulta: element["flgSoloConsulta"],
            flgSoloPractica: element["flgSoloPractica"],
            ausente: element["ausente"],
            piso: element["piso"],
            requiereAutorizacion: element["requiereAutorizacion"],
            estadoProtocolo: element["estadoProtocolo"],
            kinesioVerificaRecepcion: element["kinesioVerificaRecepcion"],
            osValidacionInterna: element["osValidacionInterna"],
            idEspecialidad: element["idEspecialidad"],
            resumen: {
              validaOnlineEstado: element["validaOnlineEstado"],
              validaOnline: element["validaOnline"],
              monto: element["monto"],
              medSolicitanteDto: element["medSolicitanteDto"],
              estadoOrden: element["estadoOrden"],
              tieneDeterminaciones: element["tieneDeterminaciones"],
            },
          };
          setTurnosSeleccionado([turno])(turnosSeleccionadosDispatch);
          setTurnoForced([turno])(turnosAutoCheckInDispatch);
          setPaso("Resumen")(pasoDispatch);
        } else {
          sessionStorage.setItem(
            "otroCentro",
            JSON.stringify(element?.coordenadaGps)
          );
          setPaso("OtroCentro")(pasoDispatch);
        }
        sessionStorage.removeItem("getOrdenes");
        sessionStorage.removeItem("ordenesList");
      } else {
        setError({
          message: "Error al traer el turno",
          errorBack: "Home",
        });
      }
      setLoading(false);
    };
    wsPostTomarAtencionSinTurnoQr(dto, nextStep)();
  };

  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  useEffect(() => {
    let nextStep = (isCorrect, data) => {
      if (isCorrect) {
        setAgendaList(data);
        setLoading(false);
      } else {
        setLoading(false);
        showToaster(
          {
            texto: "Error al obtener los turnos.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    };
    wsGetAllDemandaQr(
      -1,
      ordenDigitalState.ordenDigital.altaTurno,
      nextStep
    )(atencionSinTurnoDispatch);
  }, []);
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />

      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"ATENCIÓN SIN TURNO"}
        subtitle={
          "Elegí la especialidad que necesitás y presioná el botón 'Recepcionarme' para ingresarte."
        }
      >
        {!loading && (
          <ContainerP5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BodyContainerP5>
              {agendaList?.length > 0 ? (
                agendaList.map((element, index) => {
                  return (
                    <CardOrden key={index}>
                      <p className="header rb18m">
                        {element?.idgrupoestudio_desc === ""
                          ? "Estudio"
                          : camelize(element?.especialidad)}
                      </p>
                      <div className="bodyOrden">
                        <p>
                          Médico:{" "}
                          <span className="rb16m">{element?.profesional}</span>
                        </p>
                        <p>
                          Demora:{" "}
                          <span className="rb16m">{element?.demora}</span>
                        </p>
                        <p>
                          Centro:{" "}
                          <span className="rb16m">{element?.centro}</span>
                        </p>
                        <p>
                          Direccion:{" "}
                          <span className="rb16m">{element?.direccion}</span>
                        </p>
                        <ButtonP5
                          onClick={
                            element?.idCentro.toString() === centroQR
                              ? () => tomarTurnoDemanda(element)
                              : () => advertenciaCentro(element)
                          }
                        >
                          Recepcionarme
                        </ButtonP5>
                      </div>
                    </CardOrden>
                  );
                })
              ) : (
                <TurnoNoEncontrado
                  state={agendaList}
                  loadingState={loading}
                  recomendacion={
                    "No se encontraron agendas disponibles para la especialidad seleccionada."
                  }
                />
              )}
            </BodyContainerP5>
          </ContainerP5>
        )}
      </LayoutPasos>
    </>
  );
};

export default AgendasDisponibles;
